import { type PageBase, getCurrentPage } from '@avensia/excite';

import { convertProductToGA4, pageToDataLayerInfo } from '../utils';
import { addToDataLayer, type DataLayerEvent } from '..';

export type PromotionEventType = {
  content:
    | NordicNest.Api.NNHeroBlock
    | NordicNest.Api.NNImageBlock
    | NordicNest.Api.SvenssonsImageBlock
    | NordicNest.Api.AdApiModel
    | NordicNest.Api.ProductDiscountApiModel
    | NordicNest.Api.ImageWithFocalPointsApiModel;
  items?: NordicNest.Api.PartialProductApiModel[];
  layoutBlockId?: string;
};

export function addSelectPromotionToDataLayer(data: PromotionEventType) {
  const page = getCurrentPage() as PageBase;
  const ga4Event: DataLayerEvent = {
    event: 'select_promotion',
    ecommerce: {
      creative_name: 'not_available',
      promotion_id: data.content.id,
      promotion_name: data.content.name,
      ...pageToDataLayerInfo(page),
      items:
        data.items && data.items.length > 0
          ? data.items?.map(item => convertProductToGA4(item.trackingProductInformation))
          : 'not_available',
    },
  };

  addToDataLayer(ga4Event);
}

export function addViewPromotionToDataLayer(data: PromotionEventType) {
  const page = getCurrentPage() as PageBase;
  const ga4Event: DataLayerEvent = {
    event: 'view_promotion',
    ecommerce: {
      creative_name: 'not_available',
      promotion_id: data.content.id,
      promotion_name: data.content.name,
      ...pageToDataLayerInfo(page),
    },
    _clear: false,
  };
  if (data.items && data.items.length > 0) {
    ga4Event.ecommerce.items = data.items?.map(item => convertProductToGA4(item.trackingProductInformation));
  }
  addToDataLayer(ga4Event);
}
